import CompanyEditForm from "./company-edit-form";

export default CompanyEditForm;